import { pxToRem, sizes } from '@bos/ui';

export const appSizes = {
	...sizes,
	breakpoints: {
		xs: pxToRem(0),
		sm: pxToRem(700),
		md: pxToRem(1000),
		lg: pxToRem(1300),
		xl: pxToRem(1600),
	},
	appLayout: {
		panelWidth: pxToRem(240),
		centerMaxWidth: pxToRem(1100),
		minHeight: '100vh',
		closeButtonPadding: {
			leftRight: pxToRem(10),
		},
		noDataContentMinHeight: pxToRem(200),
	},
	grid: {
		itemMinWidth: pxToRem(280),
	},
	filter: {
		popoverWidth: pxToRem(500),
	},
	filterSelect: {
		popoverWidth: pxToRem(250),
		buttonWidth: pxToRem(250),
		popoverMaxHeight: pxToRem(280),
	},
	headerNavigation: {
		buttonBorder: pxToRem(1),
	},
	appFilterButton: {
		width: pxToRem(200),
	},
	verifyIdentityPage: {
		dialogMinHeight: pxToRem(400),
	},
	animation: {
		size: pxToRem(160),
	},
	activateApplicationsPage: {
		transitionDateColumnWidth: pxToRem(175),
	},
	identityVerificationPage: {
		transitionDateColumnWidth: pxToRem(175),
	},
	clientBankIdentity: {
		fingerprintIconSize: pxToRem(80),
		fingerprintStatusIconSize: pxToRem(32),
		fingerprintStatusIconPositionRight: pxToRem(-10),
		fingerprintStatusIconPositionTop: pxToRem(6),
		fingerprintSectionWidth: '100%',
		fingerprintSectionMaxWidth: pxToRem(240),
		loadingElementMinHeight: pxToRem(150),
		skeletonLoader: {
			titleWidth: pxToRem(300),
			titleHeight: pxToRem(24),
			ruleIconSize: pxToRem(35),
			ruleTextWidth: pxToRem(400),
			ruleTextHeight: pxToRem(32),
		},
	},
	generateReportForStateInstitution: {
		iconSize: pxToRem(80),
	},
	iconBackground: {
		padding: pxToRem(8),
		borderRadius: '50%',
	},
	textArea: {
		height: pxToRem(200),
	},
	fipHomePage: {
		cardHeight: pxToRem(348),
	},
	accordion: {
		accordionRadius: pxToRem(8),
		accordionBorderWidth: pxToRem(2),
	},
	tile: {
		standardNoDataContentMinHeight: pxToRem(180),
		smallNoDataContentMinHeight: pxToRem(65),
	},
	loginModal: {
		width: pxToRem(600),
		height: pxToRem(400),
	},
	qrCodeWrapper: {
		padding: pxToRem(15),
		borderWidth: pxToRem(2),
		maxHeight: pxToRem(170),
	},
	searchClientAccountTableHeaderRadius: pxToRem(6),
};
